import { render, staticRenderFns } from "./CheckButton.vue?vue&type=template&id=380be12a&scoped=true"
import script from "./CheckButton.vue?vue&type=script&lang=js"
export * from "./CheckButton.vue?vue&type=script&lang=js"
import style0 from "./CheckButton.vue?vue&type=style&index=0&id=380be12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380be12a",
  null
  
)

export default component.exports